import { withPopupProvider } from "../../hoc/withPopupProvider";
import { PlacementWorksheetPage as View } from "./PlacementWorksheetPage";

export const PlacementWorksheetPage = withPopupProvider(View);